import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import ProgramDropdown from "CommonDropdowns/ProgramDropdown";
import { map } from "lodash";

const ScopeModal = ({
  showScopeModal,
  handleCloseScopeModal,
  formState,
  setFormState,
  objectId,
}) => {
  const [programValue, setProgramValue] = useState([]);
  const [selectedProgramIds, setSelectedProgramIds] = useState([]);
  const [forceRender, setForceRender] = useState(false);

  // Pre-populate the dropdown when the modal opens
  useEffect(() => {
    if (showScopeModal && objectId && formState.values.role_access_rights[objectId]) {
      let existingProgramIds =
        formState.values.role_access_rights[objectId].program_ids || [];

      // Ensure program_ids is always an array for the dropdown
      if (typeof existingProgramIds === "string" && existingProgramIds) {
        existingProgramIds = existingProgramIds.split(",");
      }

      setSelectedProgramIds(existingProgramIds);
      setForceRender((prev) => !prev); // Force re-render in dropdown
    } else {
      // Clear state when modal is hidden or no objectId
      setSelectedProgramIds([]);
      setProgramValue([]);
      setForceRender(false);
    }
  }, [showScopeModal, objectId, formState]);

  // Handler for dropdown change
  const handleProgramChange = (selected) => {
    setProgramValue(selected);
  };

  // Reset state on close
  const handleClose = () => {
    handleCloseScopeModal();
  };

  // Update parent form state on save
  const handleSave = () => {
    // Ensure we have an objectId to update
    if (!objectId) {
      console.error("Save failed: objectId is missing.");
      handleClose();
      return;
    }

    const programIds = map(programValue, "value"); // Extract just the IDs
    setFormState((currentFormState) => ({
      ...currentFormState,
      values: {
        ...currentFormState.values,
        role_access_rights: {
          ...currentFormState.values.role_access_rights,
          [objectId]: {
            ...currentFormState.values.role_access_rights[objectId],
            program_ids: programIds,
            program_wise_access: programIds.length > 0, // Set access flag
          },
        },
      },
    }));
    handleClose(); // Close modal after saving
  };

  return (
    <Modal show={showScopeModal} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <h3 className="font-16 font-weight-medium">Add Scope</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ProgramDropdown
          programValue={programValue}
          setProgramValue={setProgramValue}
          programOnChange={handleProgramChange}
          isMulti={true}
          selectedId={selectedProgramIds}
          forceRender={forceRender}
          name="program_ids"
          label="Select Program"
        />
      </Modal.Body>
      <Modal.Footer className="d-inline">
        <div className="d-flex align-items-center w-100 gap-3">
          <button
            variant="none"
            className="w-100 c-b-btn"
            onClick={handleClose}
          >
            Close
          </button>
          <button variant="none" className="w-100 n-u-btn" onClick={handleSave}>
            Save
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ScopeModal;